module.exports = __webpack_public_path__ + "img/electricity-disabled.6e5842ab.png";